import { reports } from "./reports";
import { tableColumnTypes } from "../../tableColumnTypes";
import { FormattedMessage } from "react-intl";

export const quizReport = {
  label: <FormattedMessage id="QUIZ_REPORT" />,
  path: (tenantName) => `/${tenantName}/reports/quizReport`,

  navLinks: (navigate, tenantName) => [
    {
      key: 1,
      label: "Reports",
      path: `${reports.path(tenantName)}`,
      onClick: () => navigate(`${reports.path(tenantName)}`),
    },
    {
      key: 2,
      label: <FormattedMessage id="QUIZ_REPORT" />,
      path: `${reports.path(tenantName)}`,
      onClick: () => navigate(`${reports.path(tenantName)}`),
    },
  ],
  columns: (navigate, handleUserPopUp) => [
    {
      ID: 1,
      name: <FormattedMessage id="CLASS_NAME_TEXT" />,
      fieldName: "ClassNames",
      value: (row) => (
        <span
          style={{
            textDecoration:
              row.AverageQuizScore === "N/A" ? "none" : "underline",
            color: row.AverageQuizScore === "N/A" ? "#404040" : "#0051BC",
            cursor: row.AverageQuizScore === "N/A" ? "auto" : "pointer",
          }}
          onClick={() => {
            if (row.AverageQuizScore !== "N/A") handleUserPopUp(row.Id);
          }}
        >
          {row.ClassNames}
        </span>
      ),
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 2,
      name: <FormattedMessage id="TOTAL_USERS_COMPLETED" />,
      fieldName: "CompletedUsersCount",
      value: (row) => row.CompletedUsersCount,
      sort: true,
      type: tableColumnTypes.NUMBER,
    },
    {
      ID: 3,
      name: <FormattedMessage id="TOTAL_QUIZ_QUESTIONS" />,
      fieldName: "QuizQuestionsCount",
      value: (row) => row.QuizQuestionsCount,
      sort: true,
      type: tableColumnTypes.NUMBER,
    },
    {
      ID: 4,
      name: <FormattedMessage id="PASS_MARK" />,
      fieldName: "PassMarks",
      value: (row) => row.PassMarks,
      sort: true,
    },
    {
      ID: 5,
      name: <FormattedMessage id="AVERAGE_QUIZ_SCORE" />,
      fieldName: "AverageQuizScore",
      value: (row) => row.AverageQuizScore,
      sort: true,
    },
  ],
  inputField: (formArgs) => [
    {
      key: 1,
      isMulti: true,
      type: "multiSelect",
      // isRequired: true,
      name: "className",
      label: "Select Shotclasses",
      isLimit: true,
      defaultValue: formArgs.selectedClassName,
      placeholder: "Select Shotclasses",
      options: formArgs.classNameOptions,
      onChange: (e) => formArgs.onClassNameSelected(e),
      maxSelected: 10,
      validationLabel: "classes",
      selectedValue: formArgs.selectedClassName,
    },
    {
      key: 2,
      isMulti: true,
      type: "multiSelect",
      // isRequired: true,
      name: "userGroup",
      label: <FormattedMessage id="Report_User_Groups" />,
      isLimit: true,
      defaultValue: formArgs.selectedUserGroup,
      placeholder: "Select User Groups",
      options: formArgs.userGroupOptions,
      onChange: (e) => formArgs.onUserGroupSelected(e),
      maxSelected: 5,
      validationLabel: "Groups ",
      isDisabled: formArgs.selectedUser?.length > 0,
      selectedValue: formArgs.selectedUserGroup,
    },
    {
      key: 3,
      // isMulti: true,
      type: "multiSelect",
      // isRequired: true,
      name: "user",
      label: <FormattedMessage id="SELECT_USER" />,
      // isLimit: true,
      defaultValue: formArgs.selectedUser,
      placeholder: "Select User",
      options: formArgs.classNameOptions,
      onChange: (e) => formArgs.setSelectedUser(e),
      maxSelected: 1,
      validationLabel: "User ",
      isInputDisabled: formArgs.selectedUserGroup?.length > 0,
      selectedValue: formArgs.selectedUser,
    },
    {
      key: 4,
      type: "searchBtn",
      isCombine: true,
      onClick: (e) => formArgs.handleReset(e),
    },
    {
      key: 5,
      type: "searchBtn",
      isCombine: false,
      onClick: (e) => formArgs.onFilterSearch(e),
    },
  ],
};
